import type { ReactNode } from 'react';
import { pill, dot } from './Pill.css';

export function Pill({ children, dot: showDot }: { children: ReactNode; dot?: boolean }) {
  return (
    <span className={pill}>
      {showDot && <span className={dot} data-testid="pill-dot" />}
      {children}
    </span>
  );
}
